import { createReducer, on } from '@ngrx/store';
import {
  CreatedBookingEvent,
  UpdatedBookingEvent,
  GotAllBookingsEvent,
  GotAllBookingsByStatusEvent,
  GotAllBookingsBetweenDatesEvent,
  GotAllBookingsByVendorDocumentEvent,
  GotAllBookingsByResidentAndStatusEvent,
  GotAllBookingsBetweenDatesAndBuildingIdEvent,
  GotAllBookingsByBuildingIdEvent,
  UpdatedBookingProcessStatusEvent,
  InvalidBookingAccessCodeEvent,
  GotAllBookingsByResidentEvent,
  ValidatedBookingAccessCodeEvent,
} from './booking.events';
import { BookingState } from './booking.state';

export const bookingKey = 'booking';
export const initialState: BookingState = {
  error: null,
  entities: {},
  byQuery: {},
};

export const BookingReducer = createReducer<BookingState, any>(
  initialState,

  on(
    CreatedBookingEvent,
    UpdatedBookingEvent,
    UpdatedBookingProcessStatusEvent,
    (state, { entities }) => {
      const newBookings = { ...state.entities };
      entities.forEach((booking) => {
        newBookings[booking.id] = booking;
      });
      return { ...state, bookings: newBookings };
    },
  ),

  on(
    GotAllBookingsEvent,
    GotAllBookingsByStatusEvent,
    GotAllBookingsBetweenDatesEvent,
    GotAllBookingsByVendorDocumentEvent,
    GotAllBookingsByResidentAndStatusEvent,
    GotAllBookingsBetweenDatesAndBuildingIdEvent,
    GotAllBookingsByBuildingIdEvent,
    GotAllBookingsByResidentEvent,
    ValidatedBookingAccessCodeEvent,
    (state, { entities }) => {
      const newBookings = { ...state.entities };
      entities.forEach((booking: any) => {
        newBookings[booking.id] = booking;
      });
      return { ...state, entities: newBookings };
    },
  ),

  on(InvalidBookingAccessCodeEvent, (state, { error }) => {
    return { ...state, error };
  }),
);
